var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._b({tag:"component",class:_vm.classes},'component',_vm.attrs,false),[_c('span',{domProps:{"innerHTML":_vm._s(_vm.button.title)}})])}
var staticRenderFns = []

export { render, staticRenderFns }